import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { FormBuilder, FieldGroup, FieldControl, Validators } from 'react-reactive-form';
import { callAPI } from '../../../lib/Global.js';
import { swalAlert, swalToast2 } from '../../../lib/Swal.js';
import styles from "../../../styles/common.module.css";

const TextInput = ({ handler, touched, hasError, meta }) => (
    <div className="form-group d-flex">
        <label for="formControlInput1" className={`mb-1 ${styles.labelStyling} col-2`}>{meta.label}</label>
        <div className="col-4">
            <input type="text" maxLength={meta.maxLengthVal} className={`form-control ${styles.modalInputStyling}`} placeholder={`${meta.label}`} {...handler()} disabled={meta.disabled} />
            <span className="d-block text-danger">
                {touched
                    && hasError("required")
                    && `${meta.label} is required `}
                {hasError("email")
                    && `${meta.emailErrMsg} `}
                {hasError("pattern") && `${meta.patternErrMsg}`}
                {hasError("maxLength") && `Max Length of ${meta.maxLengthVal} Exceeded `}
                {hasError("minLength") && `Min Length of ${meta.minLengthVal} Required `}
                {hasError(meta.customError) && `${meta.customErrorMsg}`}
            </span>
        </div>
    </div>
);

const mobilityOptions = [{ value: 'pain', label: 'Pain' },
{ value: 'jointSwelling', label: 'Joint swelling' },
{ value: 'stiffness', label: 'Stiffness', },
{ value: 'walker', label: 'Walker', },
{ value: 'cane', label: 'Cane', },
{ value: 'bed-bound', label: 'Bed-bound', },
{ value: 'liftChair', label: 'Lift chair', },
{ value: 'hoyerLift', label: 'Hoyer lift', },
{ value: 'self', label: 'Self', },
{ value: 'wheelChair', label: 'Wheelchair', },
{ value: 'unsteadyGait', label: 'Unsteady gait', },
{ value: 'assist', label: 'Assist', },
{ value: 'totalAssist', label: 'Total assist', },
{ value: 'standBy', label: 'Stand by', },
{ value: 'paralyzed', label: 'Paralyzed' },
];

const clientMobilityForm = new FormBuilder.group({
    id: null,
    clientId: [null, Validators.required],
    mobility: null,
    others: null
});


const ClientMobilityDetails = ({ clientId }) => {
    const [isLoading, setisLoading] = useState(false);
    const [mobilityArr, setMobilityArr] = useState([]);

    useEffect(() => {
        getClientMobilityDetails(clientId);
        return () => {
            clientMobilityForm.reset();
        }
    }, [clientId]);

    const limitationChangeHandler = (e) => {
        let limitationsNew = e?.map((i) => i.value);
        clientMobilityForm.patchValue({ mobility: limitationsNew.join(',') });
        clientMobilityForm.markAsDirty();
    };

    const getClientMobilityDetails = async (clientId) => {
        setisLoading(true)
        const r = await callAPI("GetClientMobilityDetailsByClientId", { id: clientId });

        if (r) {
            clientMobilityForm.patchValue({ ...r });
            let defaultValue = r.mobility.split(',').map((dr) => mobilityOptions.find((i) => i.value === dr))
            setMobilityArr(defaultValue);
            clientMobilityForm.updateValueAndValidity(clientMobilityForm.value);
        } else {
            clientMobilityForm.patchValue({ clientId: clientId });
        }
        setisLoading(false);
    }

    const handleSave = async () => {
        clientMobilityForm.updateValueAndValidity(clientMobilityForm.value);
        setisLoading(true);

        const apiText = clientMobilityForm.value.id ? 'UpdateClientMobilityDetails' : 'AddClientMobilityDetails';
        let message = clientMobilityForm.value.id !== null ? 'Updated' : 'Saved';
        const r = await callAPI(apiText, clientMobilityForm.value);
        setisLoading(false);
        clientMobilityForm.updateValueAndValidity(clientMobilityForm.value);

        if (r.isSuccess) {
            swalToast2('Client Mobility Details ' + message + ' successfully.');
            getClientMobilityDetails(clientId);
            clientMobilityForm.markAsPristine();
        } else {
            const errorMsg = `<span class="text-danger">${r.errorMsg || 'Something went wrong!!!'}</span>`;
            swalAlert('e', errorMsg);
        }
    }

    return (
        <>
            <div className="row mb-2">
                <div className="col-12">
                    <h5 className="bold-style" style={{ fontSize: '14px' }}>Mobility</h5>
                </div>
            </div>
            <hr />
            {isLoading ? <div>Please Wait...</div> :
                <div>
                    <FieldGroup
                        control={clientMobilityForm}
                        render={({ get, invalid, pristine, dirty }) => (
                            <form>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <FieldControl
                                            name="mobility"
                                            render={({ handler, touched, hasError, meta }) => (
                                                <div className="d-flex">
                                                    <label for="formCheck1" className={`mb-1 ${styles.labelStyling} col-2`}>{meta.label}</label>
                                                    <div class="col-4">
                                                        <Select isMulti menuPlacement="bottom" options={meta.options}
                                                            defaultValue={mobilityArr}
                                                            value={meta.options.value} onChange={limitationChangeHandler}></Select>
                                                    </div>
                                                </div>
                                            )}
                                            meta={{
                                                label: "Mobility",
                                                options: mobilityOptions
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-12">
                                        <FieldControl name="others" render={TextInput} meta={{
                                            label: "Others"
                                        }} />
                                    </div>
                                </div>

                                <div className="d-flex justify-content-center">
                                    <div className="d-grid gap-2 pb-1">
                                        <button type="button" onClick={() => handleSave()} className="btn btn-primary" disabled={isLoading || invalid || pristine || !dirty}>{isLoading ? 'Please wait...' : 'Save'}</button>

                                    </div>
                                </div>

                            </form>
                        )}
                    />
                </div>
            }
        </>
    )
}

export default ClientMobilityDetails;